import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux'
import rootReducer from '../reducers';
import { Provider } from 'react-redux';
import { HashRouter, Switch } from 'react-router-dom';
import App from './App';
import createSagaMiddleware from 'redux-saga'
import { setupCognito } from 'react-cognito';
import rootSaga from '../sagas/';
import { setIdentityPoolId } from '../config'

const sagaMiddleware = createSagaMiddleware()
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

const setupCognitoHOC = (WrappedComp) => {
    return class extends Component {
        componentWillMount() {
            const { cognitoConfig, tables, buckets } = this.props;
            setupCognito(store, cognitoConfig)

            setIdentityPoolId(cognitoConfig.identityPool)

            store.dispatch({ type: 'CONFIGURE_RESOURCES', tables, buckets })
        }

        render() {
            return <WrappedComp {...this.props} />
        }
    }

}

const Root = ({...props}) => (
    <Provider store={store}>
        <HashRouter hashType="noslash">
            <Switch>
                <App {...props} />
            </Switch>
        </HashRouter>
    </Provider>
)

export default setupCognitoHOC(Root)



// WEBPACK FOOTER //
// ./src/components/Root.js